'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUndefined = isUndefined;
function isUndefined(val) {
  return typeof val === 'undefined';
}